import type { SoulSaveJob } from './soul-save-job';

const DATABASE = 'dobidobi-soul-saves-v1';
const STORE = 'jobs';

async function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DATABASE, 1);
    request.onupgradeneeded = () => {
      request.result.createObjectStore(STORE, { keyPath: 'id' }).createIndex('ownerId', 'ownerId');
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
    request.onblocked = () => reject(new Error('soulSaveUnavailable'));
  });
}

/** Resolve on transaction COMMIT, never on a put's provisional success. */
async function transact<T>(mode: IDBTransactionMode, operation: (store: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await openDatabase();
  try {
    return await new Promise<T>((resolve, reject) => {
      const transaction = db.transaction(STORE, mode);
      const request = operation(transaction.objectStore(STORE));
      transaction.oncomplete = () => resolve(request.result);
      transaction.onerror = () => reject(transaction.error ?? request.error);
      transaction.onabort = () => reject(transaction.error ?? new Error('soulSaveUnavailable'));
    });
  } finally { db.close(); }
}

export async function listSoulSaveJobs(ownerId: string): Promise<SoulSaveJob[]> {
  const jobs = await transact<SoulSaveJob[]>('readonly', (store) => store.index('ownerId').getAll(ownerId));
  return jobs.filter((job) => job.ownerId === ownerId).sort((a, b) => b.createdAt - a.createdAt);
}
export function addSoulSaveJob(job: SoulSaveJob): Promise<IDBValidKey> {
  return transact('readwrite', (store) => store.add(job));
}
export function putSoulSaveJob(job: SoulSaveJob): Promise<IDBValidKey> {
  return transact('readwrite', (store) => store.put(job));
}
export function deleteSoulSaveJob(id: string): Promise<undefined> {
  return transact('readwrite', (store) => store.delete(id));
}
